import React from "react";
import { Card, CardContent, CardHeader, Divider } from "@material-ui/core";

const SectionCard: React.FC<{ title: string; subheader?: string }> = ({ title, subheader, children }) => (
  <Card style={{ marginTop: 16 }}>
    <CardHeader title={title} subheader={subheader} />
    <Divider />
    <CardContent>{children}</CardContent>
  </Card>
);

export default SectionCard;
